// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd0d656e","453":"130a4413","667":"583ec38d"}[chunkId] + ".chunk.js";
};